<template>
  <div class="text-justify">
    <OrganizationParentReview />
    <OrganizationBranchReview />
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../apiUrl";
export default {
  name: "Organization",
  mixins: [FormMixin],
  created() {
    this.data();
  },
  methods: {
    returnPage() {
      window.location.href = "/accreditations/applications";
    },
    data() {
      this.$store.dispatch("getPoliticalDivision");

      if (this.$store.state.accreditation.org) {
        return;
      }
        var organization_id = localStorage.getItem("id_organization");
        this.axiosGet(`${actions.ORGANIZATIONS}/index/${organization_id}`)
        .then((response) => {
          if (response.status == 200) {
            this.$store.state.accreditation.org = { ...response.data };
          }
        })
        .catch((error) => {
          console.log("Organization: " + error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
};
</script>
